import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Workspace from 'src/entities/workspace';
import { getCurrentUserWorkspacesWithProjectCreationPermissions, getUserOwnsAWorkspace } from 'src/selectors/workspaces';
import { firstBy } from 'thenby';

const useFormWorkspaces = ( { initialWorkspaceID }: { initialWorkspaceID?: number } ) => {
	const workspaces: Workspace[] = useSelector(
		state => getCurrentUserWorkspacesWithProjectCreationPermissions( state )
	);
	const currentUserOwnsAWorkspace: boolean = useSelector(
		state => getUserOwnsAWorkspace( state )
	);

	const skipWorkspaceSelection = useMemo(
		() => workspaces.length === 1 && currentUserOwnsAWorkspace,
		[ workspaces, currentUserOwnsAWorkspace ]
	);

	const initialSelectedWorkspaceID: number | null = useMemo( () => {
		if ( initialWorkspaceID ) {
			return workspaces
				.find( workspace => workspace.id === initialWorkspaceID )
				?.id;
		}
		return workspaces?.length === 1
			? workspaces.first.id
			: null;
	}, [ initialWorkspaceID, workspaces ] );

	const workspaceOptions = useMemo( () => workspaces.map(
		workspace => ( { label: workspace.name, value: workspace.id, disabled: !workspace.isActive } )
	).sort(
		firstBy( ( { disabled } ) => disabled )
			.thenBy( 'label', { ignoreCase: true } )
	), [ workspaces ] );

	return {
		workspaces,
		workspaceOptions,
		skipWorkspaceSelection,
		initialSelectedWorkspaceID
	};
};

export default useFormWorkspaces;
